import { render, staticRenderFns } from "./FullScreenView.vue?vue&type=template&id=638e2bd6"
import script from "./FullScreenView.vue?vue&type=script&lang=js"
export * from "./FullScreenView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports